export const LISTING_STATUS = {
  ACTIVE: 1,
  UNPUBLISHED: 2,
  RENTED: 4,
  BOOKED: 5,
  PENDING: 7,
};
